pageId = 'page-project-delayed'

$(document).on "pjaxload##{pageId}", (e, $page, page) ->
  tower.adjustTodo()
